export default __webpack_public_path__ + "static/media/aspect_4_3.2d3ca400.svg";